import React from "react";
import { CheckCircleIcon, QrCodeIcon } from "@heroicons/react/24/outline";
import { BiInfoCircle } from "react-icons/bi";
import LiveElapsedTimer from "./LiveElapsedTimer";

export default function ActiveSessionCard({
  jobTitle,
  checkInDate,
  onCheckOutClick,
  onScanCheckOutClick,
}) {
  const formattedCheckInTime = checkInDate
    ? checkInDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "";

  return (
    <div className="text-center py-1 space-y-4 font-sans relative">
      <div className="text-emerald-500 mb-1">
        <CheckCircleIcon className="w-12 h-12 mx-auto animate-bounce text-emerald-500" />
      </div>
      <h2 className="text-base font-bold text-slate-900 tracking-tight">
        Successfully Checked In
      </h2>

      <div className="bg-slate-50/90 border border-slate-200/80 p-3.5 rounded-2xl text-left space-y-2.5 shadow-xs">
        <div>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
            Job Site
          </p>
          <p className="text-xs font-bold text-slate-900">{jobTitle}</p>
        </div>
        <div className="grid grid-cols-2 gap-3 pt-1 border-t border-slate-200/60">
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Checked In At
            </p>
            <p className="text-xs font-bold text-slate-700">{formattedCheckInTime}</p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">
              Current Status
            </p>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[10px] font-bold text-emerald-700 border border-emerald-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-ping" />
              On Site
            </span>
          </div>
        </div>
      </div>

      <LiveElapsedTimer checkInDate={checkInDate} />

      <div className="space-y-2">
        <button
          type="button"
          onClick={onCheckOutClick}
          className="w-full py-3 rounded-xl bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-500 hover:to-rose-600 text-white font-bold text-xs transition-all shadow-md active:scale-[0.98] flex items-center justify-center space-x-2 cursor-pointer"
        >
          <span>Check Out</span>
        </button>

        <button
          type="button"
          onClick={onScanCheckOutClick || onCheckOutClick}
          className="w-full py-3 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 font-bold text-xs transition-all flex items-center justify-center space-x-2 cursor-pointer shadow-xs"
        >
          <QrCodeIcon className="w-4 h-4 text-slate-500" />
          <span>Scan Site QR &amp; Check Out</span>
        </button>
      </div>

      <div className="pt-1 text-center">
        <p className="text-[10px] text-slate-500 font-medium flex items-center justify-center gap-1">
          <BiInfoCircle size={13} className="text-slate-400 shrink-0" />
          <span>You can check out using the button above or scanning the QR code again.</span>
        </p>
      </div>
    </div>
  );
}
